import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private environmentObj = environment;
  
  constructor() { }

  getAllConf() {
    return this.environmentObj;
  }

  get basePath(){
    return this.getAllConf().basePath;
  }
  
}
